import React, { useState, useEffect } from 'react';
const XlsIcon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4.66667 0H16.6667L22 5.33333V21.3333C22 22.8061 20.8061 24 19.3333 24H4.66667C3.19391 24 2 22.8061 2 21.3333V2.66667C2 1.19391 3.19391 0 4.66667 0Z", fill: `url(#${id})` }),
        React.createElement("path", { d: "M13.8365 18L11.9965 14.6934L10.1698 18H8.0498L10.9965 13.1334L8.23647 8.50671H10.3431L11.9965 11.5734L13.6631 8.50671H15.7565L12.9965 13.1334L15.9565 18H13.8365Z", fill: "white" }),
        React.createElement("path", { d: "M16.667 4V0L22.0003 5.33333H18.0003C17.2639 5.33333 16.667 4.73638 16.667 4Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "12", y1: "0", x2: "12", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#2BC491" }),
                React.createElement("stop", { offset: "1", stopColor: "#1EA87A" })))));
};
export default XlsIcon;
